<template>
  <div class="fill-height d-flex align-center flex-column justify-center">
    <div class="error-container text-text-secondary">
      <app-material-icon name="scan_delete" size="lg" />

      <h3>{{ errorTitle }}</h3>
      <p class="mt-2 mb-8">{{ errorMessage }}</p>

      <AppDownloadFile v-if="canDownloadFile" :link="fileLink">
        <template #default="{ submitForm }">
          <app-button
            type="outlined"
            variant="neutral"
            @click="submitForm"
          >
            {{ buttonLabel }}
          </app-button>
        </template>
      </AppDownloadFile>
      <app-button
        v-else
        class="mx-auto"
        type="outlined"
        variant="neutral"
        @click="closeViewer"
      >
        {{ buttonLabel }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppDownloadFile from '@/common/AppDownloadFile.vue'
import { ERROR_CODES } from '@/common/document-viewer/constants'
import { roomFileDownloadUrl } from '@/common/utils/files'
import { ROOMS_ROUTE_NAME } from '@/router/routerData'

export default {
  name: 'DocumentViewerErrors',
  components: {
    AppDownloadFile,
  },
  props: {
    fileName: {
      type: String,
      default: '',
    },
    fileFromPdfjsError: {
      type: [Object, null],
      default: null,
    },
    errorCode: {
      type: String,
      default: '',
    },
    file: {
      type: Object,
      default: null,
    },
    mnemo: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileLink () {
      return this.file?.id && this.mnemo ? roomFileDownloadUrl(this.file.id, this.mnemo) : null
    },
    errorTitle() {
      return this.errorCode === ERROR_CODES.INVALID_PDF_EXCEPTION
        ? this.$t('common.DocumentViewer.loadingDocumentError.fileTypeNotSupportedTitle')
        : this.$t('common.DocumentViewer.loadingDocumentError.title')
    },
    errorMessage() {
      if (this.fileFromPdfjsError) {
        if (this.errorCode === ERROR_CODES.INVALID_PDF_EXCEPTION) {
          return this.$t('common.DocumentViewer.loadingDocumentError.fileTypeNotSupported', { fileName: this.fileName })
        }
        return this.fileName
          ? this.$t('common.DocumentViewer.loadingDocumentError.technicalErrorWithFile', { fileName: this.fileName })
          : this.$t('common.DocumentViewer.loadingDocumentError.technicalError')
      }

      if (this.errorCode === ERROR_CODES.ERR_NOT_FOUND) {
        return this.$t('common.DocumentViewer.loadingDocumentError.fileNotFound')
      }

      if (this.errorCode === ERROR_CODES.SERVER_ERROR) {
        return this.fileName
          ? this.$t('common.DocumentViewer.loadingDocumentError.technicalErrorWithFile', { fileName: this.fileName })
          : this.$t('common.DocumentViewer.loadingDocumentError.technicalError')
      }

      return this.$t('common.DocumentViewer.loadingDocumentError.genericError')
    },
    canDownloadFile() {
      return this.errorCode === ERROR_CODES.INVALID_PDF_EXCEPTION && this.file?.id && this.file?.canDownload
    },
    buttonLabel() {
      return this.canDownloadFile
        ? this.$t('common.DocumentViewer.downloadFileLabel')
        : this.$t('common.DocumentViewer.closeViewerLabel')
    },
  },
  methods: {
    closeViewer () {
      if (window.opener) {
        window.close()
      } else {
        // The browser does not support window.close() if the window was not opened by JS
        // (e.g. user opened manually a new tab)
        // In this case, we redirect the user to the rooms page
        this.$router.replace({ name: ROOMS_ROUTE_NAME })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.error-container {
  max-width: 600px;
  margin: 0 auto;
  overflow-wrap: break-word;
  text-align: center;
}
</style>
